<sm-title-bar [pageTitle]="pageTitle" [back]="true"> </sm-title-bar>
<div class="" *ngIf="!loader && memberAllInvoiceList.length > 0">
  <div>
    <div class="plan-card" style="position: relative;" *ngFor="let data  of memberAllInvoiceList">
      <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options"
        style="position: absolute; right: 10px; top: 15px;  color:#333">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu2="matMenu">
        <button mat-menu-item (click)="viewDetails(data)" [disabled]="!data.hash_id">
          <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
          <span>View invoice</span>
        </button>
           <button mat-menu-item (click)="refund(data)" [disabled]="!data.hash_id">
          <mat-icon class="material-icons-outlined">swap_vertical_circle</mat-icon>
          <span>Refund payment</span>
        </button>
      </mat-menu>

      <div class="d-flex " style="align-items: center;">
        <h2 class="plan-title"> {{data.inv_no}}</h2>
      </div>
      <p class="plan-info">
        <span class="label">Amount: </span> <span class="value">{{data.currency_symbol}}{{data.total_price.toFixed(2)}}</span>,
        <span class="label">Due: </span> <span class="value">{{data.currency_symbol}}{{data.payment_due.toFixed(2)}}</span>
      </p>
      <p class="plan-cost">
        <span class="value">Refund status: {{data.refund_status}}</span>
      </p>
      <p class="plan-cost">
        <span class="value">{{data.creation_time | date}}, {{data.creation_time | date: 'shortTime' : 'UTC'}}</span>
      </p>
         <!-- <div class="arrow_due" >
            <mat-icon>arrow_forward</mat-icon>
          </div> -->
    </div>
  </div>
</div>



<div class="row" *ngIf="!loader && memberAllInvoiceList.length == 0">
  <div class="col-sm-12" >
    <div style="padding: 20px 18px 20px 18px;border-radius: var(--dra-radius-x-small);transition: 0.3s;">
      <div class="top_section_order">
        <div class="row">
         <div class="nal_rrty">
          <div style="text-align:center;min-height: 500px;padding-top: 210px">
          <div class="cv_notifia">
             <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 682.667 682.667" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><defs><clipPath id="a" clipPathUnits="userSpaceOnUse"><path d="M0 512h512V0H0Z" fill="#808080" opacity="1" data-original="#000000"></path></clipPath></defs><g clip-path="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)"><path d="M0 0v-106c0-11.046-8.954-20-20-20h-200c-11.046 0-20 8.954-20 20v452c0 11.046 8.954 20 20 20h200c11.046 0 20-8.954 20-20V240" style="stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(276 136)" fill="none" stroke="#808080" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" opacity="1" class=""></path><path d="M0 0v-120c0-11.046-8.954-20-20-20h-320c-11.046 0-20 8.954-20 20V80c0 11.046 8.954 20 20 20h320c11.046 0 20-8.954 20-20V40" style="stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(476 276)" fill="none" stroke="#808080" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" opacity="1" class=""></path><path d="M0 0h240" style="stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(36 70)" fill="none" stroke="#808080" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" opacity="1" class=""></path><path d="M0 0h360v-40H0" style="fill-opacity:1;fill-rule:nonzero;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(116 316)" data-original="#000000"></path><path d="M0 0h240" style="stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(36 442)" fill="none" stroke="#808080" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" opacity="1" class=""></path><path d="M0 0h120" style="stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(296 196)" fill="none" stroke="#808080" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" opacity="1" class=""></path><path d="M0 0v-19.13" style="stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(156 462)" fill="none" stroke="#808080" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" opacity="1" class=""></path><path d="M0 0v-19.13" style="stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(156 70)" fill="none" stroke="#808080" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" opacity="1" class=""></path></g></g></svg>
          </div>
          <div>
            <p style="margin-top: 18px; color: #888; font-size: 17px;  line-height: 24px;">
              There's no payment record to show here. Check whether invoices are raised to this member yet.  
           </p>
         </div>
          </div>
        </div>
       </div>
      </div>
    </div>
  </div>
</div>





<!-- <mat-card appearance="outlined">
  <mat-card-header class="justify-content-between align-items-center mb-3">
  </mat-card-header>
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="memberAllInvoiceList" [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate" [showPagination]="true" [itemsPerPage]="25">
    </sm-data-table>
  </div>
</mat-card>
<ng-template #menuTemplate let-rowvalue>
  <button mat-menu-item (click)="viewDetails(rowvalue)">
    <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
    <span>View invoice</span>
  </button>
</ng-template> -->
<!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->